import { call, put, takeEvery, select } from 'typed-redux-saga'
import {
	infotecsApi,
	registratorCabinetActions,
	InfotecsNS,
	infotecsSlice,
	orderEditSlice,
	SPOD_STATUS,
	getResultDocumentsSpod,
	infotecsSelectors,
	orderEditSelectors,
} from 'Pages/registratorCabinet'
import {
	errorHandler,
	NOTIFICATION_TYPE,
	showNotificationAction,
	notifyMessageCreator,
	loadersSlice,
} from 'Modules'
import { getEditRbidosRequestSaga } from './orderEdit'

export function* getInfotecsData(action: InfotecsNS.getInfotecsData) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(infotecsApi.getInfotecsData, action.payload.id)
		if (action.payload.reloadRbidosRequest) {
			const { id } = yield* select(orderEditSelectors.getOne)
			yield* call(getEditRbidosRequestSaga, orderEditSlice.actions.getOne({ id }))
		}
		yield* put(infotecsSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* reloadInfotecsData(action: InfotecsNS.reloadInfotecsData) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id } = action.payload
		if (id) {
			yield* call(infotecsApi.reloadInfotecsData, id)
		}
		yield* call(notifyMessageCreator, 'rbidos.infotex_update.requested')
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* repeatIdentification(action: InfotecsNS.repeatIdentification) {
	try {
		const { id, data, request_id } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(infotecsApi.repeatIdentification, id, data)
		yield* put(infotecsSlice.actions.clearOne())
		yield* put(orderEditSlice.actions.getOne({ id: request_id }))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* infotecsReloadDataSocket(action: InfotecsNS.infotecsReloadDataSocket) {
	try {
		yield* call(getInfotecsData, infotecsSlice.actions.getOne({ id: String(action.payload.id) }))
		const infotecsData = yield* select(infotecsSelectors.getOne)
		const resultSpod = getResultDocumentsSpod(infotecsData?.documents)
		if (resultSpod !== SPOD_STATUS.PROCESSING) {
			yield* put(
				showNotificationAction({
					type: NOTIFICATION_TYPE.SUCCESS,
					message: 'Документ проверен. Результат доступен возле области загрузки файла',
				})
			)
		}
	} catch (error) {
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Ошибка при обновлении данных из инфотекс по сокету',
			})
		)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* sendToInfotecsSaga(action: InfotecsNS.sendToInfotecs) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(infotecsApi.sendToInfotecsApi, action.payload.id)
		const res = yield* call(infotecsApi.reloadInfotecsData, action.payload.id)
		yield* put(infotecsSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* cancelIdentificationSaga(action: InfotecsNS.cancelIdentification) {
	try {
		yield* call(infotecsApi.cancelIdentification, action.payload.id)
		const res = yield* call(infotecsApi.reloadInfotecsData, action.payload.id)
		yield* put(infotecsSlice.actions.setOne(res))
		yield* call(
			getEditRbidosRequestSaga,
			orderEditSlice.actions.getOne({ id: action.payload.rbidos_id })
		)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* searchInfotecsSaga(action: InfotecsNS.infotecsSearch) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(infotecsApi.infotecsSearch, action.payload.id)
		const bindRes = yield* call(infotecsApi.rbidosBind, res.id, action.payload.id)
		yield* put(infotecsSlice.actions.setOne(bindRes))
		yield* call(infotecsApi.reloadInfotecsData, res.id)
		yield* call(getEditRbidosRequestSaga, orderEditSlice.actions.getOne({ id: action.payload.id }))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* infotecsSaga() {
	yield* takeEvery(infotecsSlice.actions.getOne.type, getInfotecsData)
	yield* takeEvery(registratorCabinetActions.reloadInfotecsData.type, reloadInfotecsData)
	yield* takeEvery(registratorCabinetActions.repeatIdentification.type, repeatIdentification)
	yield* takeEvery(
		registratorCabinetActions.infotecsReloadDataSocket.type,
		infotecsReloadDataSocket
	)
	yield* takeEvery(registratorCabinetActions.sendToInfotecs.type, sendToInfotecsSaga)
	yield* takeEvery(registratorCabinetActions.cancelIdentification.type, cancelIdentificationSaga)
	yield* takeEvery(registratorCabinetActions.infotecsSearch.type, searchInfotecsSaga)
}
